import React, { useState, useEffect} from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import JoinWaitlist from './JoinWaitlist';
import { useLocation } from "react-router-dom";
import SignUpModal from '../snippets/modal/SignUpModal';
import { useDispatch, useSelector } from 'react-redux';
import { getFirstName } from '../action/functions';
import { bindActionCreators } from 'redux';
import { actionCreator } from '../redux';
import SignInModal from '../snippets/modal/SignInModal';


const Navbar = () => {

  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [isVerifyEmailModalOpen, setIsVerifyEmailModalOpen] = useState(false);
  const [isJoinWaitlistModalOpen, setIsJoinWaitlistModalOpen] = useState(false);
  
  const [menuOpen, setMenuOpen] = useState(false);
  const [,setLogoutOpen] = useState(false);
  const [calculatorMenu, setCalculatorMenu] = useState(false);

  const location = useLocation();
  const calculatorPages = ["/farmcalculator", "/feed-calculator", "/egg-calculator", "/space-calculator"];
  const isCalculatorPage = calculatorPages.some((path) => location.pathname.includes(path));
  const account = useSelector(state => state.account);
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreator, dispatch); 

  const [isClicked, setIsClicked] = useState(() => {
    return localStorage.getItem("calculatorClicked") === "true";
  });

  useEffect(() => {
    if (!account || !account.isAuthenticated) return;

    const refreshEntry = async () => {
      let now = new Date();
      if (now.getTime() < account.expiry) return;
      await logout();
    }
    refreshEntry();

    const refreshTimer = setInterval(async () => {
      await refreshEntry();
    }, 60000);

    return () => clearInterval(refreshTimer);
  }, [account, logout]);
  
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);


  const handleClick = () => {
    const storedState = localStorage.getItem("calculatorClicked");
    
    oepnCalculatorMenu();
  
    if (storedState === "true") return;
  
    const newState = !isClicked;
    setIsClicked(newState);
    localStorage.setItem("calculatorClicked", newState); 
  };
  

  const oepnCalculatorMenu = () => {
    setCalculatorMenu(true);
  };

  const closeCalculatorMenu = () => {
    setCalculatorMenu(false);
  };

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const openSignInModal = () => {
    setIsSignInModalOpen(true);
    setIsSignupModalOpen(false);
    setCalculatorMenu(false);
  };

  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };

  const openSignupModal = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(true);
  };

  const closeSignupModal = () => {
    setIsSignupModalOpen(false);
  };

  const openVerifyEmailModal = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(false);
    setIsVerifyEmailModalOpen(true);
  };

  const closeVerifyEmailModal = () => {
    setIsVerifyEmailModalOpen(false);
  };

  const openJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(true);
  };

  const closeJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(false);
  };

  const handleLogin = () => {
    closeSignInModal();
    setMenuOpen(false);
  }

  const toggleLogout = () => {
    setLogoutOpen((prev) => !prev);
  };
 
  const handleLogout = async () => {
    await logout();
    window.location = "/";
  }

  return (
    <>
      <nav className="navbar">
        <Link to='/' className='desktop-logo'>
          <img src="/assets/rairer-logo.svg" alt="Rairer Logo" className="logo" />
        </Link>
        {account && account.isAuthenticated ? (
          menuOpen ? (
            <Link className="mobile-username">
              <img src={account.profile_pic} alt="Avatar" className="avatar-mobile" />             
              <p className="navLink-mobile">Hi, {getFirstName(account.fullname)}</p>  
            </Link>
          ) : (
            <Link to='/' className='mobile-logo'>
              <img src="/assets/rairer-logo.svg" alt="Rairer Logo" className="logo" />
            </Link>
          )
        ):(
          <Link to='/' className='mobile-logo'>
            <img src="/assets/rairer-logo.svg" alt="Rairer Logo" className="logo" />
          </Link>
        )}
        <div className='menu-icon-container'>
        {isCalculatorPage && (
          <div onClick={handleClick}>
            <img 
              src={isClicked ? "/assets/calculator-clicked.svg" : "/assets/calculator.svg"}
              alt="Calculator Icon"
              className="menuIcon" 
            />
          </div>
        )}
        <div onClick={toggleMenu}>
          <img 
            src={menuOpen ? "/assets/close-line.svg" : "/assets/menu_icon.svg"} 
            alt={menuOpen ? "Close Menu" : "Open Menu"} 
            className="menuIcon" 
          />
        </div>
        </div>

        <ul className="navLinks">
          <li className="application-container">
            <Link className="farm-navLink-container">
              <p className="farm-navLink">Farm Calculator</p>
              <img src="/assets/arrow-down.png" alt="Down Arrow" className="menu_arrow" />
            </Link>
            <div className='dropdown-menu-container'>
              <div className="dropdown-menu">
                <Link className='poultry-menu'>
                  <p className="poultry-calculator">Poultry Calculator</p>
                  <img src="/assets/sub-menu-arrow.svg" alt="sub-menu"/>
                </Link>
                <p className="herd-item">Herd Calculator</p>
              </div>              
              <div className="submenu">
                <Link 
                    to={account && account.isAuthenticated ? '/space-calculator' : '#'} 
                    onClick={() => {
                      if (!account.isAuthenticated) {
                        openSignInModal();
                      }
                    }}
                    className="submenu-item first-active"
                  >
                    My Space Calculator
                </Link>
                <Link 
                    to={account && account.isAuthenticated ? '/feed-calculator' : '#'} 
                    onClick={() => {
                      if (!account.isAuthenticated) {
                        openSignInModal();
                      }
                    }}
                    className="submenu-item"
                  >
                    Feed Calculator
                </Link>
                <Link 
                    to={account && account.isAuthenticated ? '/egg-calculator' : '#'} 
                    onClick={() => {
                      if (!account.isAuthenticated) {
                        openSignInModal();
                      }
                    }}
                    className="submenu-item last-active"
                  >
                    Egg Production Calculator
                </Link>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <Link className="navLink" onClick={openJoinWaitlistModal}>Join Waitlist</Link>
          </li> 
          <li>
            <Link to="/#about" className="navLink">About</Link>
          </li>
        </ul>
        <div className="authLinks">
          {account && account.isAuthenticated ? (
            <div className='signed-user-container'>
            <Link className="dropdown" onClick={toggleLogout}>
              <img src={account.profile_pic} alt="Avatar" className="menu_arrow" />
              <div className="dropdown">
                <p className="navLink">{getFirstName(account.fullname)}</p>
                <img src="/assets/arrow-down.png" alt="Down Arrow" className="menu_arrow" />
              </div>     
            </Link>
            <div className='logout-container'>
              <div className="logout-dropdown-menu">
                <Link className='poultry-menu logout-menu' onClick={handleLogout}>
                  <p className="poultry-calculator logout">Logout</p>
                </Link>
              </div>
            </div>
            </div>
          ):(
            <>
              <Link className="navLink" onClick={openSignInModal}>Log in</Link>
              <Link className="signUp" onClick={openSignupModal}>Sign up for free</Link>
            </>
          )}
        </div>
      </nav>
      {menuOpen && (
        <div className='mobile-menu-dropdown'>
          <nav  className='menu-item-container'>
            <Link to='/' className='menu-item-mobile' onClick={toggleMenu}>Home</Link>
            <Link to='/farmcalculator' className='menu-item-mobile' onClick={toggleMenu}>Farm Calculator</Link>
            <Link className='menu-item-mobile' onClick={openJoinWaitlistModal}>Join Waitlist</Link>
            <Link to="/#about" className='menu-item-mobile' onClick={toggleMenu}>About Us</Link>
          </nav>
          <div className='signin-container'>
            {account && account.isAuthenticated ? (     
              <>
                <Link className='signin-mobile' onClick={handleLogout}>Log out</Link>
              </>       
            ):(
              <>
                <Link className='signin-mobile' onClick={openSignInModal}>Sign in</Link>
                <Link className='create-account-mobile' onClick={openSignupModal}>Create free account</Link>
              </>
            )}
          </div>
        </div>
      )}

      {calculatorMenu && (
        <div className="modal-overlay" onClick={closeCalculatorMenu}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={closeCalculatorMenu}/>
            <h2 className="modal-title">Select Calculator</h2>
            <div className='calculator-menu-container'>
              <Link 
                to={account && account.isAuthenticated ? '/space-calculator' : '#'} 
                onClick={() => {
                  if (!account.isAuthenticated) {
                    openSignInModal();
                  }
                }}
                className='calculator-menu'
              >
                <img src='/assets/my-space-menu.svg'  alt="space-menu"/>
                <p>My Space Calculator</p>
              </Link>
              <Link
                to={account && account.isAuthenticated ? '/feed-calculator' : '#'} 
                onClick={() => {
                  if (!account.isAuthenticated) {
                    openSignInModal();
                  }
                }}
                className='calculator-menu'
              >
                <img alt="feed-menu" src='/assets/feed-menu-icon.svg'/>
                <p>My Feed Calculator</p>
              </Link>
              <Link 
                to={account && account.isAuthenticated ? '/egg-calculator' : '#'} 
                onClick={() => {
                  if (!account.isAuthenticated) {
                    openSignInModal();
                  }
                }}
                className='calculator-menu'
              >
                <img src='/assets/egg-menu-icon.svg'  alt="egg-menu"/>
                <p>Egg Production Calculator</p>
              </Link>
            </div>
          </div>
        </div>
      )}

      {isSignInModalOpen && (
        <SignInModal closeSignIn={closeSignInModal} openSignUp={openSignupModal} onSubmit={handleLogin}  />
      )}

      {isSignupModalOpen && (
        <SignUpModal closeSignup={closeSignupModal} openSignIn={openSignInModal} onSubmit={openVerifyEmailModal} />
      )}

      {isVerifyEmailModalOpen && (account && account.isAuthenticated) && (
        <div className="modal-overlay" onClick={closeSignupModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon'  onClick={closeVerifyEmailModal}/>
            <div className='modal-main-container'>
              <h2 className="modal-title">Verify Email</h2>
              <div className='signup-modal-container'>
                <DotLottieReact
                  src="/assets/hatching-chick.json"
                  loop
                  autoplay
                  className='canvas'
                />
                <div className='modal-input-container'>
                  <p className='verify-text'>To continue, complete this verification step. We've sent a verification link to <span style={{color: '#3EC182'}}>{account.email}</span>.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isJoinWaitlistModalOpen && (
        <JoinWaitlist closeJoinWaitlistModal={closeJoinWaitlistModal}/>
      )}
    </>
  );
};

export default Navbar;
